
import { Component, Vue } from "vue-property-decorator";
import { Table } from "@common/src/utils/decorator";
import { formDownload } from "@common/src/utils/tools";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { namespace } from "vuex-class";
const finance = namespace("finance");
const service = namespace("service");
const base = namespace("base");
const serviceItem = namespace("service-item");
const category = namespace("parts-category");
@Component
@Table("loadListData")
export default class SalesSummary extends Vue {
  @service.State retailTypeOption;
  @base.Action getDictionaryList;
  @category.Action getCategoryList;
  @serviceItem.Action queryTwoLevelClassList;
  @finance.Action salesOrderReportQueryList;
  @finance.Action salesOrderReportDownload;
  itemTypeList = [];
  serviceCategoryList = [];
  partsCategoryList = [];
  get searchList() {
    return [
      {
        label: this.$t("speedbiz-v217_0.order-create-date"),
        type: "daterange",
        value: "",
        prop: "createTime",
        valueDistribute: ["beginOrderTime", "endOrderTime"]
      },
      {
        label: this.$t("speedbiz-v217_0.order-payment-date"),
        type: "daterange",
        value: "",
        prop: "payTime",
        valueDistribute: ["beginPaidTime", "endPaidTime"]
      },
      {
        label: this.$t("v213.Order-No"),
        type: "input",
        value: "",
        prop: "orderNo"
      },
      {
        label: this.$t("other.order-type"),
        type: "select",
        selectList: [
          {
            label: this.$t("service.the-shop-order"),
            value: "1"
          },
          {
            label: this.$t("service.booking-order"),
            value: "2"
          }
        ],
        value: "",
        prop: "orderType"
      },
      {
        label: this.$t("speedbiz-v217_0.sales-type"),
        type: "select",
        selectList: this.retailTypeOption,
        value: "",
        prop: "retailType"
      },
      {
        label: this.$t("speedbiz-v217_0.itemsType"),
        type: "select",
        selectList: this.itemTypeList,
        value: "",
        prop: "itemType"
      },
      {
        label: this.$t("speedbiz-v217_0.serviceCategory"),
        type: "select",
        selectList: this.serviceCategoryList,
        value: "",
        prop: "serviceCategoryCode"
      },
      {
        label: this.$t("speedbiz-v217_0.serviceName"),
        type: "input",
        value: "",
        prop: "serviceName"
      },
      {
        label: this.$t("speedbiz-v217_0.partsCategory"),
        type: "select",
        selectList: this.partsCategoryList,
        value: "",
        prop: "partsCategoryCode"
      },
      {
        label: this.$t("speedbiz-v217_0.partsName"),
        type: "input",
        value: "",
        prop: "partsName"
      }
    ];
  }
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  searchForm = {};
  summaryList = [];
  sumInfo: any = {};
  getSummaries() {
    const {
      avgGrossProfitRate,
      sumGrossProfit,
      sumIncludingTaxAmount,
      sumOrderAmount,
      sumPurchaseIncludingTaxAmount,
      sumPurchaseTaxAmount,
      sumPurchaseTaxableAmount,
      sumSalesTax,
      sumSavingTax,
      sumTaxableAmount
    } = this.sumInfo;
    const sums = [
      "",
      "-",
      "-",
      sumOrderAmount,
      sumIncludingTaxAmount,
      sumSalesTax,
      sumSavingTax,
      sumTaxableAmount,
      sumPurchaseIncludingTaxAmount,
      sumPurchaseTaxAmount,
      sumPurchaseTaxableAmount,
      sumGrossProfit,
      avgGrossProfitRate
    ].map(item => (item === "" || item === "-" ? item : splitThousands(item)));
    return sums;
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }

  handleExportData() {
    formDownload(`${window.API_URL}/report/salesOrderReport/queryList/download`, this.searchForm);
  }
  addLeafFlag(list) {
    const f = function (list) {
      list.forEach(item => {
        if (!item.children || item.children.length < 1) {
          delete item.children;
        } else {
          f(item.children);
        }
      });
    };
    f(list);
    return list;
  }
  getDict() {
    this.getDictionaryList("sales_order_item_type").then(data => {
      this.itemTypeList = data;
    });
    this.queryTwoLevelClassList({ pageNum: 1, pageSize: 1000 }).then(data => {
      this.serviceCategoryList = (data.data.list || []).map(item => {
        return {
          label: item.serviceCategoryName,
          value: item.serviceCategoryCode
        };
      });
    });
    this.getCategoryList({ pageNum: 1, pageSize: 1000 }).then(data => {
      this.partsCategoryList = this.addLeafFlag(this.$safeValue(data, "data", [])).map(item => {
        return {
          label: item.categoryName,
          value: item.categoryCode
        };
      });
    });
  }
  created() {
    this.getDict();
    this.loadListData();
  }
  handleLinkPartsDetail(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.orderNo}`
    });
    window.open(href, "_blank");
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.salesOrderReportQueryList({
      ...this.searchForm,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    }).then(data => {
      const {
        list,
        avgGrossProfitRate,
        sumGrossProfit,
        sumIncludingTaxAmount,
        sumOrderAmount,
        sumPurchaseIncludingTaxAmount,
        sumPurchaseTaxAmount,
        sumPurchaseTaxableAmount,
        sumSalesTax,
        sumSavingTax,
        sumTaxableAmount
      } = data.data;
      this.summaryList = list;
      this.sumInfo = {
        avgGrossProfitRate,
        sumGrossProfit,
        sumIncludingTaxAmount,
        sumPurchaseIncludingTaxAmount,
        sumPurchaseTaxAmount,
        sumOrderAmount,
        sumPurchaseTaxableAmount,
        sumSalesTax,
        sumSavingTax,
        sumTaxableAmount
      };
      return data;
    });
  }
}
